module.exports = __webpack_public_path__ + "files/0b3d8e76693b04da67a641c20e5c4c3c.svg";